import _ from 'lodash';

export default class UsersService {
  constructor(SeldaAPIService, $q, localStorageService) {
    'ngInject';
    Object.assign(this, {SeldaAPIService, $q, localStorageService});
  }


  login(credentials) {
    let params = {matricola: credentials.username, password: credentials.password};
    return this.SeldaAPIService.requestService('login', params)
    // if login is correct an array with one user is returned else [false] is returned as data
      .then((response) => response[0] ? response[0] : this.$q.reject('No such user'))
      .then(this.saveCurrentUser.bind(this));
  }

  logout() {
    console.debug('Logging out user');
    this.localStorageService.remove('currentUser');
    return this.$q.when(); // return a promise just in case
  }

  saveCurrentUser(user) {
    user.starredOffices = user.starredOffices || [];
    this.localStorageService.set('currentUser', user);
    console.debug('Saving logged in user', user, 'in localstorage');
    return user;
  }

  /**
   * Return application current user if any
   */
  currentUser() {
    return this.localStorageService.get('currentUser');
  }

}


// WEBPACK FOOTER //
// ./client/app/services/users_service.js